import { createTheme } from '@mui/material/styles'
import darkScrollbar from '@mui/material/darkScrollbar'
import base from './base'

const theme = createTheme(base, {
    id: 'summit',
    name: 'Summit Connect',
    devexpress: 'material.summit',
    logo: 'sumLogo.svg',
    scheme: 'SkyBlue',
    palette: {
        secondary: {
            main: '#4697cb',
            trans: '#4697cb99',
            dark: '#3f7aa0',
            contrastText: '#ffffff',
            level1: '#1f4056',
            level2: '#234f6d',
            level3: '#2a5f82',
            level4: '#33729b',
            level5: '#3c88ba',
            level6: '#459ed8',
            level7: '#4eb0f0',
        },
        spcBooking: {
            main: '#4697cb',
            comp: '#33729b',
        },
        spcBookingNotOwned: {
            main: '#3f7aa0',
            comp: '#33729b',
        },
        pieChart: ['#4eb0f0', '#459ed8', '#3c88ba', '#33729b', '#2a5f82', '#234f6d', '#1f4056'],
    },
    header: {
        selector: {
            color: "#4697cb",
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: darkScrollbar(),
                // ***** Devexpress theme additions *****
                '&.dx-button.dx-button-has-icon.dx-state-hover': {
                    color: '#4697cb',
                },
                '&.dx-toolbar .dx-button .dx-icon:hover': {
                    color: '#4697cb',
                },
                '&.dx-list-item.dx-state-active, .dx-list-item.dx-state-hover': {
                    color: '#4697cb',
                },
                '&.dx-device-mobile .dx-list-item.dx-state-active, .dx-device-mobile .dx-list-item.dx-state-hover': {
                    color: '#4697cb',
                },
                '&.dx-device-mobile .dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-state-focused': {
                    color: '#4697cb',
                },
                '&.dx-device-mobile .dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-state-focused.dx-list-item-selected': {
                    backgroundColor: '#2b2b2b',
                    color: '#4697cb',
                },
                '.dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-list-item-selected.dx-state-hover:not(.dx-state-focused)': {
                    backgroundColor: '#2b2b2b',
                    color: '#4697cb',
                },
                // ***** Devexpress theme overrides *****
                '&.dx-form-group-caption': {
                    color: '#4697cb',
                },
                '&.dx-progressbar-status': {
                    color: '#4697cb',
                },
                '&.dx-popup-title': {
                    color: '#4697cb',
                },
                '&.dx-accordion-item-title-caption': {
                    color: '#4697cb',
                },
                '&.dx-button-mode-text.dx-button-default': {
                    color: '#4697cb',
                },
                '&.daterange .dx-button-mode-text.dx-state-hover': {
                    backgroundColor: '#4697cb10',
                },
                '&.daterange .dx-button-mode-text': {
                    backgroundColor: '#4697cb14',
                },
                '&.daterange .dx-button-text': {
                    color: '#4697cb',
                },
                '&.tbarbutton.dx-button.dx-button-default': {
                    color: '#4697cb',
                    backgroundColor: '#4697cb14',
                },
                '&.tbarbutton.dx-button.dx-button-default.dx-state-hover': {
                    backgroundColor: '#4697cb10',
                },
                '&.tbarbutton.dx-button.dx-button-default.dx-state-focused': {
                    backgroundColor: '#4697cb10',
                },
                '&.dx-button.dx-state-focused, .dx-button.dx-state-hover': {
                    backgroundColor: '#4697cb78',
                },
                '&.dx-button-mode-contained.dx-state-selected': {
                    backgroundColor: '#4697cb',
                },
                '&.dx-button-mode-contained.dx-state-selected.dx-state-hover': {
                    backgroundColor: '#4697cb78',
                },
                '&.dx-button-mode-contained.dx-state-selected, .dx-button-mode-contained.dx-state-selected .dx-icon': {
                    color: '#2b2b2b',
                },
                '&.dx-scheduler-header .dx-toolbar .dx-button, .dx-scheduler-header .dx-toolbar .dx-button .dx-icon': {
                    backgroundColor: '#4697cb14',
                },
                '&.dx-designer-viewport .dxd-icon-highlighted:hover .dxd-icon-fill': {
                    fill: '#4697cb',
                    opacity: 1,
                },
                '&.dxrdp-parameters-submit.dx-state-hover': {
                    backgroundColor: '#4697cb78',
                },
                '&.dx-button.dx-button-default.dx-state-hover': {
                    backgroundColor: '#459ed8',
                },
                '&.dx-button.dx-button-default.dx-state-focused': {
                    backgroundColor: '#459ed8',
                },
                '&.dx-texteditor.dx-state-active::before, .dx-texteditor.dx-state-focused::before': {
                    borderBottom: '1px solid #4697cb',
                },
                '&.dx-state-selected > .dx-treeview-item': {
                    color: '#4697cb',
                },
                '&.dx-treeview-item-without-checkbox.dx-state-selected > .dx-treeview-item.dx-state-hover:not(.dx-state-focused)': {
                    color: '#4697cb',
                    backgroundColor: 'rgba(255,255,255,.10)',
                },
                '&.dx-treeview-item-without-checkbox.dx-state-selected > .dx-treeview-item': {
                    color: '#4697cb',
                    backgroundColor: 'rgba(255,255,255,.10)',
                },
                '&.dx-treeview-item-without-checkbox.dx-state-focused > .dx-treeview-item': {
                    color: '#4697cb',
                    backgroundColor: 'rgba(255,255,255,.10)',
                },
                '&.dx-treeview-item.dx-state-hover': {
                    color: '#4697cb',
                    backgroundColor: '#1a1a1a',
                },
                '&.dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-state-focused': {
                    color: '#4697cb',
                },
                '&.dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-state-focused.dx-list-item-selected': {
                    color: '#4697cb',
                },
                '&.dx-list:not(.dx-list-select-decorator-enabled) .dx-list-item.dx-list-item-selected': {
                    color: '#4697cb',
                },
                '&.dx-tile.dx-state-focused, .dx-tile.dx-state-hover': {
                    backgroundColor: '#4697cb',
                    color: '#2b2b2b',
                },
                '&.dx-button-mode-contained.dx-state-selected': {
                    backgroundColor: '#4697cb',
                },
                '&.dx-button-mode-contained.dx-state-selected, .dx-button-mode-contained.dx-state-selected .dx-icon': {
                    color: '#2b2b2b',
                },
                '&.dx-designer-viewport .dxd-state-active .dxd-icon-fill, .dx-designer-viewport .dxd-back-contrast .dxd-back-highlighted:hover .dxd-icon-fill, .dx-designer-viewport .dx-menu-item .dx-state-focused.dxd-icon-fill': {
                    fill: '#4697cb',
                },
                '&.dx-designer .dx-designer-viewport .dxrd-designer-wrapper.dxrd-designer-wrapper .dxrd-right-panel .dxrd-right-panel-header': {
                    color: '#4697cb',
                },
                '&.dxrdp-parameters-submit': {
                    background: '#4697cb',
                    color: '#2b2b2b',
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        color: '#4697cb',
                    },
                }
            }
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        color: "#4697cb"
                    },
                },
            }
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        color: "#4697cb"
                    },
                }
            }
        },
    },
});
export default theme
